export default (feature) => {
	let returnKey;
	// no feature data key found already so find key that has iso data
	Object.keys(feature).forEach((key) => {
		if ( feature[key] && feature[key].iso_a2 ) {
			returnKey = key;
		}
	});
	return returnKey;
};
